<div class="solutions">
  <h2>مجوزات و افتخارات</h2>
  <p></p>
  <div class="boxes">
    <!--    <div class="brand" routerLink="/brands/pardakhtsazi">-->
    <!--      <div class="line" style="background: #8224e3; box-shadow: 0 -19px 25px 1px #64242491;"></div>-->
    <!--      <div class="item">-->
    <!--        <p>کسب مجوز پرداخت‌بانی از بانک مرکزی جمهوری اسلامی و شاپرک</p>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="brand" routerLink="/brands/pardakhtsazi">
      <div class="line" style="background: #50d1dd; box-shadow: 0 -19px 25px 1px #64242491"></div>
      <div class="item">
        <p>کسب مجوز پرداخت‌یاری از بانک مرکزی جمهوری اسلامی و شاپرک</p>
      </div>
    </div>

    <div class="brand" routerLink="/brands/pardakhtsazi">
      <div class="line" style="background: #ed2027; box-shadow: 0 -19px 25px 1px #64242491"></div>
      <div class="item">
        <p>کسب مجوز پرداخت‌سازی از بانک مرکزی جمهوری اسلامی و شاپرک</p>
      </div>
    </div>

    <div class="brand" routerLink="/brands/pardakhtsazi">
      <div class="line" style="background: #642424; box-shadow: 0 -19px 25px 1px #64242491"></div>
      <div class="item">
        <p>کسب تندیس سیمین ششمین همایش ملی کیفیت</p>
      </div>
    </div>
    <div class="brand" routerLink="/brands/pardakhtsazi">
      <div class="line" style="background: orange; box-shadow: 0 -19px 25px 1px #64242491"></div>
      <div class="item">
        <p>ارتقاء مجوز دانش‌بنیان به تولیدی نوع ۲</p>
      </div>
    </div>
    <!-- <div class="item">
      <p>کسب تندیس سیمین ششمین همایش ملی کیفیت</p>
      <div class="area"></div>
    </div>
    <div class="item">
      <p>کسب مجوز پرداخت‌یاری از بانک مرکزی جمهوری اسلامی و شاپرک</p>
      <div class="area"></div>
    </div>
    <div class="item">
      <p>کسب مجوز پرداخت‌سازی از بانک مرکزی جمهوری اسلامی و شاپرک</p>
      <div class="area"></div>
    </div>
    <div class="item">
      <p>کسب مجوز پرداخت‌بانی از بانک مرکزی جمهوری اسلامی و شاپرک</p>
      <div class="area"></div>
    </div> -->
  </div>
</div>
<div class="content"></div>
<br />
<br />

<br />
